import React from 'react';
import './YoyAwdUploadPopup.css';

function YoyAwdUploadPopup({
  showAwdUploadPopup,
  setShowAwdUploadPopup,
  awdFileInputRef,
  selectedAwdFile,
  setSelectedAwdFile,
  parsedAwdData,
  setParsedAwdData,
  uploadAwdStatus,
  setUploadAwdStatus,
  handleAwdFileUpload,
  handleAwdUploadSubmit
}) {
  
  const closeAwdUploadPopup = () => {
    setShowAwdUploadPopup(false);
    setSelectedAwdFile(null);
    setParsedAwdData([]);
    setUploadAwdStatus(null);
    if (awdFileInputRef.current) {
      awdFileInputRef.current.value = '';
    }
  };
  
  return (
    <>
      {showAwdUploadPopup && (
        <div className="awd-popup-overlay">
          <div className="awd-popup-content">
            <div className="awd-popup-header">
              <h2>
                Upload Amazon Warehouse Deals (AWD) Data
              </h2>
              <button 
                className="awd-close-popup"
                onClick={closeAwdUploadPopup}
              >
                ✕
              </button>
            </div>
            
            <div className="awd-upload-form">
              {/* Информация о формате файла */}
              <div className="awd-file-info">
                <h3>File Format Requirements</h3>
                <ul>
                  <li><strong>Required columns:</strong> ASIN, Inbound to AWD (units), Available in AWD (units)</li>
                  <li><strong>Supported formats:</strong> CSV, Excel (.xlsx, .xls)</li>
                  <li><strong>Auto-detection:</strong> System will automatically find header row</li>
                  <li><strong>File size:</strong> Maximum 10MB</li>
                </ul>
              </div>
              
              {/* Выбор файла */}
              <div className="form-group">
                <label>
                  Select File *
                </label>
                <div className="awd-file-upload">
                  <input
                    type="file"
                    ref={awdFileInputRef}
                    accept=".csv,.xlsx,.xls"
                    onChange={handleAwdFileUpload}
                    style={{ display: 'none' }}
                  />
                  <button
                    className="awd-file-upload-btn"
                    onClick={() => awdFileInputRef.current.click()}
                  >
                    {selectedAwdFile ? (
                      <>
                        {selectedAwdFile.name}
                      </>
                    ) : (
                      <>
                        Choose CSV or Excel file
                      </>
                    )}
                  </button>
                  {selectedAwdFile && (
                    <span className="awd-file-size">
                      {(selectedAwdFile.size / 1024).toFixed(2)} KB
                    </span>
                  )}
                </div>
                <p className="awd-file-hint">
                  The system will automatically detect the header row with column names
                </p>
              </div>
              
              {/* Статус загрузки */}
              {uploadAwdStatus && (
                <div className={`awd-upload-status ${uploadAwdStatus.type}`}>
                  {uploadAwdStatus.type === 'loading' ? (
                    <>
                      {uploadAwdStatus.message}
                    </>
                  ) : uploadAwdStatus.type === 'success' ? (
                    <>
                      {uploadAwdStatus.message}
                    </>
                  ) : (
                    <>
                      {uploadAwdStatus.message}
                    </>
                  )}
                  {uploadAwdStatus.details && (
                    <div className="status-details">
                      {uploadAwdStatus.details}
                    </div>
                  )}
                </div>
              )}
              
              {/* Предпросмотр данных */}
              {parsedAwdData.length > 0 && (
                <div className="awd-data-preview">
                  <div className="preview-header">
                    <h3>
                      Data Preview ({parsedAwdData.length} rows)
                    </h3>
                    <div className="preview-stats">
                      <span className="stat-item">
                        Unique ASINs: {new Set(parsedAwdData.map(row => row.asin)).size}
                      </span>
                      <span className="stat-item">
                        Total Inbound: {parsedAwdData.reduce((sum, row) => sum + (row.inbound_to_awd || 0), 0).toLocaleString()}
                      </span>
                      <span className="stat-item">
                        Total Available: {parsedAwdData.reduce((sum, row) => sum + (row.available_in_awd || 0), 0).toLocaleString()}
                      </span>
                    </div>
                  </div>
                  <div className="preview-table-container">
                    <table className="preview-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>ASIN</th>
                          <th>Inbound to AWD</th>
                          <th>Available in AWD</th>
                        </tr>
                      </thead>
                      <tbody>
                        {parsedAwdData.slice(0, 10).map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td className="asin-cell">
                              {row.asin || 'N/A'}
                            </td>
                            <td className="number-cell">
                              <span className={row.inbound_to_awd > 0 ? "positive-value" : "zero-value"}>
                                {row.inbound_to_awd || 0}
                              </span>
                            </td>
                            <td className="number-cell">
                              <span className={row.available_in_awd > 0 ? "positive-value" : "zero-value"}>
                                {row.available_in_awd || 0}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {parsedAwdData.length > 10 && (
                      <p className="preview-more">
                        ⋮ ... and {parsedAwdData.length - 10} more rows
                      </p>
                    )}
                  </div>
                </div>
              )}
              
              {/* Кнопки действий */}
              <div className="awd-popup-buttons">
                <button
                  className="awd-cancel-btn"
                  onClick={closeAwdUploadPopup}
                >
                  Cancel
                </button>
                <button
                  className="awd-submit-btn"
                  onClick={handleAwdUploadSubmit}
                  disabled={!selectedAwdFile || parsedAwdData.length === 0 || uploadAwdStatus?.type === 'loading'}
                >
                  {uploadAwdStatus?.type === 'loading' ? (
                    <>
                      Processing...
                    </>
                  ) : (
                    <>
                      Upload to Database
                    </>
                  )}
                </button>
              </div>
              
              {/* Примечания */}
              <div className="awd-notes">
                <h4>
                  Important Notes
                </h4>
                <ul>
                  <li>All existing AWD data will be replaced with new data</li>
                  <li>System automatically detects the header row with column names</li>
                  <li>Rows with empty or invalid ASIN will be skipped</li>
                  <li>Large files may take several seconds to process</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default YoyAwdUploadPopup;
